import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

export const STATUS_CHIP_PALETTES = {
  Active: {
    color: "#1b5e20",
    borderColor: "#2e7d32",
    backgroundColor: "#e8f5e9",
  },
  Suspended: {
    color: "#212121",
    borderColor: "#9e9e9e",
    backgroundColor: "#fafafa",
  },
  Revoked: {
    color: "#212121",
    borderColor: "#9e9e9e",
    backgroundColor: "#fafafa",
  },
  Invited: {
    color: "#bf360c",
    borderColor: "#ffb74d",
    backgroundColor: "#fff8e1",
  },
};

export const NEUTRAL_CHIP_PALETTE = {
  color: "#616161",
  borderColor: "#bdbdbd",
  backgroundColor: "#f5f5f5",
};

export const AccessStatusChipRoot = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "$palette",
})(({ $palette }) => ({
  height: 28,
  borderRadius: 999,
  fontWeight: 600,
  fontSize: "0.8125rem",
  border: "1px solid",
  backgroundColor: $palette.backgroundColor,
  color: $palette.color,
  borderColor: $palette.borderColor,
  "& .MuiChip-label": {
    paddingLeft: 12,
    paddingRight: 12,
  },
}));

export const AccessStatusSelectRoot = styled(Box)({
  width: "100%",
});

export const AccessStatusVisuallyHiddenLabel = styled(Box)({
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap",
});

export const AccessStatusOptionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "$selected" && prop !== "$palette",
})(({ theme, $selected, $palette }) => ({
  borderRadius: 999,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.8125rem",
  minWidth: "auto",
  paddingLeft: theme.spacing(1.25),
  paddingRight: theme.spacing(1.25),
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  lineHeight: 1.25,
  ...($selected
    ? {
        backgroundColor: $palette.backgroundColor,
        color: $palette.color,
        border: `1px solid ${$palette.borderColor}`,
        "&:hover": {
          backgroundColor: $palette.backgroundColor,
          borderColor: $palette.borderColor,
        },
      }
    : {
        backgroundColor: "transparent",
        color: theme.palette.text.secondary,
        border: "1px solid",
        borderColor: theme.palette.divider,
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
          borderColor: theme.palette.text.disabled,
        },
      }),
}));
